module.exports = __webpack_public_path__ + "img/CM.4f0af353.svg";